import { responseCategories } from './apiConstants';
import objectUtil from '../../util/object/objectUtil';

class ResponseHandler {
    static isResponseError(error: any): boolean {
        return objectUtil.hasOwnProp('errorType', error);
    }

    handleAlert: (alert: any) => void;
    handleNotLoggedIn: () => void;
    handleForbidden: (message?: string) => void;
    checkIsViewOnlyImpersonation?: () => boolean;

    constructor(handlers: any) {
        this.handleAlert = handlers.handleAlert || this.handleAlert;
        this.handleNotLoggedIn = handlers.handleNotLoggedIn || this.handleNotLoggedIn;
        this.handleForbidden = handlers.handleForbidden || this.handleForbidden;
        this.checkIsViewOnlyImpersonation = handlers.checkIsViewOnlyImpersonation || (() => false);
    }

    async handleApiResponse(response: Response, fileDownload?: boolean): Promise<any> {
        const responseType = this.getResponseType(response);
        if (responseType === responseCategories.OK) {
            try {
                if (fileDownload) {
                    return await response.blob();
                }

                const responseJSON = await response.json();
                this.checkForAlerts(responseJSON);
                return responseJSON;
            } catch (error) {
                return Promise.reject({ error, response, errorType: responseCategories.RESPONSE_PARSING_ERROR });
            }
        }

        if (responseType === responseCategories.NOT_LOGGED_IN) {
            this.handleNotLoggedIn();
        }

        if (responseType === responseCategories.FORBIDDEN && this.checkIsViewOnlyImpersonation?.()) {
            this.handleForbiddenResponse();
        }
        return Promise.reject({ response, errorType: responseType });
    }

    getResponseType(response: Response): responseCategories {
        switch (response.status) {
        case 200:
            return responseCategories.OK;
        case 401:
            return responseCategories.NOT_LOGGED_IN;
        case 403:
            return responseCategories.FORBIDDEN;
        case 409:
            return responseCategories.WRONG_TOKEN;
        default:
            return responseCategories.HTTP_ERROR;
        }
    }

    checkForAlerts(response: any): void {
        if ('alert' in response && this.handleAlert) {
            this.handleAlert({
                ...response.alert,
                api: response.api,
            });
        }
    }

    handleForbiddenResponse(): never {
        try {
            if (typeof this.handleForbidden === 'function') {
                this.handleForbidden();
            }
        } catch (handlerErr) {
            console.warn('handleForbidden threw:', handlerErr);
        }

        const err = new Error('FORBIDDEN');
        // eslint-disable-next-line no-underscore-dangle
        (err as any)._alertHandled = true;
        throw err;
    }
}

export default ResponseHandler;
